import { initializeApp } from 'firebase/app'
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBY4BsIdW0ljOgb-vz-Wq2jnNfwxyRW7xo',
  authDomain: 'maestro-connect-2e3f0.firebaseapp.com',
  projectId: 'maestro-connect-2e3f0',
  storageBucket: 'maestro-connect-2e3f0.firebasestorage.app',
  messagingSenderId: '126157978509',
  appId: '1:126157978509:web:1a4145c92da89aa225dbc4',
}

// FIXED: Safe environment variable access for Vite with fallback to window.location.origin
const getBaseUrl = (): string => {
  // PRODUCTION FIX: Always use production domain for email verification
  // This ensures verification emails contain the correct domain regardless of where the code runs
  return 'https://maestroconnect.io'
}

export const actionCodeSettings = {
  // CRITICAL: Use production domain for email verification links
  url: 'https://maestroconnect.io/email-verified',
  // This must be true for email verification
  handleCodeInApp: true,
  // Adding iOS and Android settings for completeness
  iOS: {
    bundleId: 'com.maestroconnect.app',
  },
  android: {
    packageName: 'com.maestroconnect.app',
    installApp: true,
    minimumVersion: '12',
  },
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// FIXED: Disable AppCheck in development to prevent aggressive rate limiting
// Only enable in production
const isProduction = import.meta.env?.PROD || false

if (isProduction) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(
        '6LcYVkIsAAAAAB5EubLJ4HP4yZFVfPSy5Tuf9lc9',
      ),
      isTokenAutoRefreshEnabled: true,
    })
    console.log('[Firebase] AppCheck enabled for production')
  } catch (error) {
    console.error('[Firebase] AppCheck initialization failed:', error)
    // Continue without AppCheck if it fails
  }
} else {
  console.log('[Firebase] AppCheck disabled for development')
}

// Get Firebase services
export const auth = getAuth(app)

// CRITICAL FIX: Set persistence to LOCAL for mobile reliability
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('[Auth] Persistence set to browserLocalPersistence')
  })
  .catch((error) => {
    console.error('[Auth] Failed to set persistence:', error)
  })

export const db = getFirestore(app)
export const storage = getStorage(app)

export default app
